<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-textarea
            label="Message"
            v-model.trim="doc.message"
            type="text"
            auto-grow
            rows="4"
            placeholder="Message"
            id="message"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserMessageForm",
  data() {
    return {
      titleRules: [(v) => !!v || "Field is required"],
    };
  },
  props: {
    doc: Object,
  }
};
</script>
